module.exports = __webpack_public_path__ + "images/mobile/stars/todolist-ed2b93ff1208ee6777afb05e3df6eba1.png";